'use strict';

const tokenReplace = require('dibs-token-replace');
const tracking = require('dibs-tracking');

const breadcrumbLabelMap = {
    designers: 'interiors-main',

    profile: 'trade firm-profile',
    favorites: 'trade firm-favorites',
    projects: 'trade firm-projects',
    project: 'trade firm-project',
};

const vpvMap = {
    base: '/vpv/designers/{firm}/',
    profile: 'profile/',
    favorites: 'collections/',
    projects: 'projects/',
    project: 'projects/{project}/',
    gallery: 'projects/{project}/photos/',
};

function getTradeProfilesVpv(page, { firm, project }) {
    const vpv = vpvMap.base + vpvMap[page];
    return tokenReplace(vpv, { firm, project });
}

function trackTradeProfilesVpv({ page, firm, project, customDimensions }) {
    tracking.trackPageview({
        url: getTradeProfilesVpv(page, { firm, project }),
        additional: customDimensions,
    });
}

function trackTradeProfilesBreadcrumbClick(currPage, nextPage) {
    tracking.trackEvent({
        label: `${breadcrumbLabelMap[currPage]}|${breadcrumbLabelMap[nextPage]}`,
        category: 'navigation',
        action: 'breadcrumb click',
    });
}

module.exports = {
    getTradeProfilesVpv,
    trackTradeProfilesVpv,
    trackTradeProfilesBreadcrumbClick,
};



// WEBPACK FOOTER //
// ./assets/js/tradeProfiles/trackingHelpers.es.js